import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'


// 查看更多
var clickNum = 0
var initshowliNum = 8
var showstep = 4
var totalli = $('.section1 .list1 li').length

if (totalli <= initshowliNum) {
    $('.section1 .cont .list1-more').hide()
}

$('.section1 .cont .list1-more span').on('click', function () {
    clickNum += 1
    if (initshowliNum + showstep * clickNum < totalli) {
        for (let i = 0; i < showstep; i++) {
            $('.section1 .list1 li').eq(initshowliNum + (clickNum - 1) * showstep + i).show()
        }
    } else {
        for (let i = 0; i < totalli - clickNum * showstep; i++) {
            $('.section1 .list1 li').eq(initshowliNum + (clickNum - 1) * showstep + i).show()
        }
        $('.section1 .cont .list1-more').hide()
    }
})